import React from 'react';
import { Row, Col, Divider } from 'antd';
import moment from 'moment';

import { Arrendatario } from './Arrendatario';
import { Texto } from '../Texto';

import * as S from '../styles';

export function Veiculo({ veiculo }) {
  const splitTitle = veiculo?.proprietario?.detalheTipoCadastro?.split(' ');
  const tituloDadosVeiculo = `${splitTitle[1] || ''} ${splitTitle[2] || ''}`;

  return (
    <Col span={24} style={{ margin: '24px 0', padding: '0 26px 0 0' }}>
      <Row justify="center" style={{ marginBottom: '12px' }}>
        <Col span={24}>
          <S.TituloDetalheVeiculo>{`Dados cadastrais ${tituloDadosVeiculo}`}</S.TituloDetalheVeiculo>
        </Col>
      </Row>
      <Row
        gutter={[2, 8]}
        style={{ marginBottom: '16px' }}
        justify="space-between"
      >
        <Col className="gutter-row" span={4}>
          <Texto titulo="Placa" valor={veiculo?.placa || '-'} />
        </Col>
        <Col className="gutter-row" span={4}>
          <Texto titulo="Renavam" valor={veiculo?.renavam || '-'} />
        </Col>
        <Col className="gutter-row" span={4}>
          <Texto titulo="Chassi" valor={veiculo?.chassi || '-'} />
        </Col>
        <Col className="gutter-row" span={4}>
          <Texto titulo="Cor" valor={veiculo?.cor || '-'} />
        </Col>
        <Col className="gutter-row" span={4}>
          <Texto titulo="Modelo" valor={veiculo?.modelo || '-'} />
        </Col>
      </Row>
      <Row
        gutter={[2, 8]}
        style={{ marginBottom: '16px' }}
        justify="space-between"
      >
        <Col className="gutter-row" span={4}>
          <Texto titulo="Marca" valor={veiculo?.marca || '-'} />
        </Col>
        <Col className="gutter-row" span={4}>
          <Texto titulo="Carroceria" valor={veiculo?.carroceria || '-'} />
        </Col>
        <Col className="gutter-row" span={4}>
          <Texto titulo="Tipo" valor={veiculo?.tipo || '-'} />
        </Col>
        <Col className="gutter-row" span={4}>
          <Texto
            titulo="Data de licenciamento"
            valor={
              (veiculo?.dataLicenciamento &&
                moment(veiculo?.dataLicenciamento).format('DD/MM/YYYY')) ||
              '-'
            }
          />
        </Col>
        <Col className="gutter-row" span={4}>
          <Texto
            titulo="Cidade Licenciamento"
            valor={veiculo?.cidadeLicenciamento || '-'}
          />
        </Col>
      </Row>

      <Row gutter={[2, 8]} style={{ margin: '8px 0' }} justify="space-between">
        <Col className="gutter-row" span={24}>
          <Divider
            style={{
              marginBottom: '16px',
              padding: 0,
              border: '1px solid #C2CCD1',
            }}
          />
        </Col>
      </Row>

      <Row justify="center" gutter={[0, 8]}>
        <Col span={24}>
          {veiculo?.proprietario?.pessoaFisicaCadastro?.cpf ? (
            <ProprietarioPF veiculo={veiculo} />
          ) : (
            <ProprietarioPJ veiculo={veiculo} />
          )}
        </Col>
      </Row>
      <Row justify="center" gutter={[0, 8]}>
        <Col span={24}>
          {veiculo?.arrendatario && (
            <Arrendatario arrendatario={veiculo?.arrendatario} />
          )}
        </Col>
      </Row>
    </Col>
  );
}

function ProprietarioPF({ veiculo }) {
  return (
    <Col span={24} style={{ margin: '16px 0' }}>
      <Row justify="center" style={{ marginBottom: '16px' }}>
        <Col span={24}>
          <S.TituloDetalheVeiculo>{`Dados cadastrais ${veiculo?.proprietario?.detalheTipoCadastro}`}</S.TituloDetalheVeiculo>
        </Col>
      </Row>
      <Row
        gutter={[2, 8]}
        style={{ marginBottom: '16px' }}
        justify="space-between"
      >
        <Col span={4}>
          <Texto
            titulo="Nome"
            valor={veiculo?.proprietario?.pessoaFisicaCadastro?.nome || '-'}
          />
        </Col>
        <Col span={4}>
          <Texto
            titulo="CPF"
            valor={
              veiculo?.proprietario?.pessoaFisicaCadastro?.cpfFormatado || '-'
            }
          />
        </Col>
        <Col span={4}>
          <Texto
            titulo="Nome da Mãe"
            valor={veiculo?.proprietario?.pessoaFisicaCadastro?.nomeMae || '-'}
          />
        </Col>
        <Col span={4}>
          <Texto
            titulo="Nome do Pai"
            valor={veiculo?.proprietario?.pessoaFisicaCadastro?.nomePai || '-'}
          />
        </Col>
        <Col span={4}>
          <Texto
            titulo="Contato"
            valor={veiculo?.proprietario?.telefone || '-'}
          />
        </Col>
      </Row>
      <Row
        gutter={[2, 8]}
        style={{ marginBottom: '16px' }}
        justify="space-between"
      >
        <Col span={4}>
          <Texto
            titulo="Nº id. do trabalhador (NIT)"
            valor={
              veiculo?.proprietario?.pessoaFisicaCadastro?.numeroPIS || '-'
            }
          />
        </Col>
        <Col span={4}>
          <Texto
            titulo="RNTRC"
            valor={veiculo?.proprietario?.proprietarioCadastro?.rntrc || '-'}
          />
        </Col>
        <Col span={4}>
          <Texto
            titulo="Validade RNTRC"
            valor={RetornaDataFormatada(
              veiculo?.proprietario?.proprietarioCadastro?.vencimentoRNTRC
            )}
          />
        </Col>
        <Col span={4}>
          <Texto
            titulo="UF Endereço"
            valor={veiculo?.proprietario?.dadosEndereco?.uf || '-'}
          />
        </Col>
        <Col span={4}>
          <Texto
            titulo="Endereço"
            valor={veiculo?.proprietario?.endereco || '-'}
          />
        </Col>
      </Row>
    </Col>
  );
}

function ProprietarioPJ({ veiculo }) {
  return (
    <Col span={24} style={{ margin: '16px 0' }}>
      <Row justify="center" style={{ marginBottom: '16px' }}>
        <Col span={24}>
          <S.TituloDetalheVeiculo>{`Dados cadastrais ${veiculo?.proprietario?.detalheTipoCadastro}`}</S.TituloDetalheVeiculo>
        </Col>
      </Row>
      <Row
        justify="space-between"
        style={{ marginBottom: '16px' }}
        gutter={[2, 8]}
      >
        <Col span={4}>
          <Texto
            titulo="Nome Fantasia"
            valor={
              veiculo?.proprietario?.pessoaJuridicaCadastro?.nomeFantasia || '-'
            }
          />
        </Col>
        <Col span={4}>
          <Texto
            titulo="CNPJ"
            valor={
              veiculo?.proprietario?.pessoaJuridicaCadastro?.cnpjFormatado ||
              '-'
            }
          />
        </Col>
        <Col span={4}>
          <Texto
            titulo="RNTRC"
            valor={veiculo?.proprietario?.proprietarioCadastro?.rntrc || '-'}
          />
        </Col>
        <Col span={4}>
          <Texto
            titulo="Validade RNTRC"
            valor={RetornaDataFormatada(
              veiculo?.proprietario?.proprietarioCadastro?.vencimentoRNTRC
            )}
          />
        </Col>
        <Col span={4}>
          <Texto
            titulo="Insc. Estadual"
            valor={
              veiculo?.proprietario?.pessoaJuridicaCadastro
                ?.inscricaoEstadual || '-'
            }
          />
        </Col>
      </Row>
      <Row justify="start" gutter={[2, 0]}>
        <Col span={5}>
          <Texto
            titulo="Contato"
            valor={veiculo?.proprietario?.telefone || '-'}
          />
        </Col>
        <Col>
          <Texto
            titulo="Endereço"
            valor={veiculo?.proprietario?.endereco || ''}
          />
        </Col>
      </Row>
    </Col>
  );
}

const RetornaDataFormatada = data =>
  (data && moment(data).format('DD/MM/YYYY')) || '-';
